import { 

    UPDATE_PLEDGE_INSURANCE_DATA , 
    UPDATE_WASIYAT_DATA,
    RESET_PLEDGE_DATA,
    UPDATE_CPF_DATA,
    UPDATE_SELECTED_PLEDGE,
    UPDATE_DOCUMENTS,
    REMOVE_DOCUMENT,
    UPDATE_CATEGORY_PLEDGE
} from '../constants';

export function updateSelectedPledge(id){
    return {
        type: UPDATE_SELECTED_PLEDGE,
        id
    }
}

export function updatePledgeInsurance(insurance) {
    return {
        type: UPDATE_PLEDGE_INSURANCE_DATA,
        insurance
    }

}

export function updateWasiyatData(wasiat) {
     return {
        type: UPDATE_WASIYAT_DATA,
        wasiat
     }
}

export function updateCPFData(cpf)
{
    return {
        type: UPDATE_CPF_DATA,
        cpf
    }
}

export function resetPledgeData() {
    return {
        type : RESET_PLEDGE_DATA
    }
}

export function updateDocuments(category, documents) {
    return {
        type: UPDATE_DOCUMENTS,
        payload: { category, documents }
    };
}

export function removeDocument(category, documentToRemove) {
    return {
        type: REMOVE_DOCUMENT,
        payload: {
            category,
            documentToRemove
        }
    }
};

export function updateCategory(category)
{
    return {
        type: UPDATE_CATEGORY_PLEDGE,
        category
    }
}
